/* Dawn/Shrine thumbnails: silky drag WITHOUT breaking click-to-switch */
(() => {
  const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;
  if (isTouchDevice) return;

  // 一次性注入拖动时禁用 snap（避免咔咔）
  if (!document.getElementById("zm-thumb-drag-css")) {
    const style = document.createElement("style");
    style.id = "zm-thumb-drag-css";
    style.textContent = `
      .thumbnail-list.zm-thumb-drag { cursor: grab; user-select:none; -webkit-user-select:none; }
      .thumbnail-list.zm-thumb-drag.zm-thumb-dragging { cursor: grabbing; scroll-snap-type:none !important; scroll-behavior:auto !important; }
      .thumbnail-list.zm-thumb-dragging * { scroll-snap-align:none !important; }
    `;
    document.head.appendChild(style);
  }

  function enable(ul) {
    if (!ul || ul.dataset.zmThumbDrag === "1") return;
    ul.dataset.zmThumbDrag = "1";
    ul.classList.add("zm-thumb-drag");

    const DRAG_THRESHOLD = 10; // 越大越容易“点中切图”，越不容易误判拖动

    let pointerId = null;
    let down = false;
    let dragging = false;

    let startX = 0;
    let startLeft = 0;

    // 惯性
    let lastX = 0;
    let lastT = 0;
    let v = 0;
    let inertiaId = null;

    const stopInertia = () => {
      if (inertiaId) cancelAnimationFrame(inertiaId);
      inertiaId = null;
    };

    const startInertia = () => {
      const friction = 0.94;
      const boost = 18;
      const minV = 0.02;

      if (Math.abs(v) < 0.05) {
        ul.classList.remove("zm-thumb-dragging");
        return;
      }

      let vv = v;
      let last = performance.now();

      const step = () => {
        const now = performance.now();
        const dt = now - last;
        last = now;

        ul.scrollLeft -= vv * dt * boost;
        vv *= friction;

        if (Math.abs(vv) > minV) {
          inertiaId = requestAnimationFrame(step);
        } else {
          inertiaId = null;
          ul.classList.remove("zm-thumb-dragging");
        }
      };

      inertiaId = requestAnimationFrame(step);
    };

    // ✅ 关键：只有当“真的拖动”才 capture
    ul.addEventListener("pointerdown", (e) => {
      if (e.button !== 0) return;
      // 不阻止默认，不 capture，让主题 button 的 click 有机会正常工作
      down = true;
      dragging = false;
      pointerId = e.pointerId;

      stopInertia();

      startX = e.clientX;
      startLeft = ul.scrollLeft;

      lastX = e.clientX;
      lastT = performance.now();
      v = 0;
    });

    ul.addEventListener("pointermove", (e) => {
      if (!down) return;

      const dxFromStart = e.clientX - startX;

      // 还没进入拖动：必须超过阈值才开始“接管”
      if (!dragging) {
        if (Math.abs(dxFromStart) < DRAG_THRESHOLD) return;

        dragging = true;
        ul.classList.add("zm-thumb-dragging");
        // 现在才 capture，避免抢走“点击”
        ul.setPointerCapture?.(pointerId);
      }

      // 进入拖动后：更新速度和滚动
      const now = performance.now();
      const dt = Math.max(1, now - lastT);
      const dx = e.clientX - lastX;

      v = dx / dt;
      lastX = e.clientX;
      lastT = now;

      ul.scrollLeft = startLeft - dxFromStart;
    });

    ul.addEventListener("pointerup", (e) => {
      if (!down) return;
      down = false;

      // 如果从未进入 dragging，那就是“点击”，我们完全不干预 —— 让主题正常切大图
      if (!dragging) return;

      // 进入 dragging：松手惯性，并拦截一次 click（防止拖完误点）
      ul.releasePointerCapture?.(pointerId);

      const blockOnce = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        ul.removeEventListener("click", blockOnce, true);
      };
      ul.addEventListener("click", blockOnce, true);

      startInertia();
    });

    ul.addEventListener("pointercancel", () => {
      down = false;
      if (dragging) {
        dragging = false;
        ul.classList.remove("zm-thumb-dragging");
      }
    });
  }

  function init() {
    document
      .querySelectorAll('slider-component[id^="GalleryThumbnails-"] ul.thumbnail-list')
      .forEach((ul) => {
        if (ul.scrollWidth > ul.clientWidth + 10) enable(ul);
      });
  }

  init();
  setTimeout(init, 600);
  setTimeout(init, 1500);
})();
